// WORKAROUND: Our queries don't convert strings to dates

// WORKAROUND: TRef fields might not be populated
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export let ECurrencyCode;
(function (ECurrencyCode) {
  ECurrencyCode["AED"] = "AED";
  ECurrencyCode["AFN"] = "AFN";
  ECurrencyCode["ALL"] = "ALL";
  ECurrencyCode["AMD"] = "AMD";
  ECurrencyCode["ANG"] = "ANG";
  ECurrencyCode["AOA"] = "AOA";
  ECurrencyCode["ARS"] = "ARS";
  ECurrencyCode["AUD"] = "AUD";
  ECurrencyCode["AWG"] = "AWG";
  ECurrencyCode["AZN"] = "AZN";
  ECurrencyCode["BAM"] = "BAM";
  ECurrencyCode["BBD"] = "BBD";
  ECurrencyCode["BDT"] = "BDT";
  ECurrencyCode["BGN"] = "BGN";
  ECurrencyCode["BHD"] = "BHD";
  ECurrencyCode["BIF"] = "BIF";
  ECurrencyCode["BMD"] = "BMD";
  ECurrencyCode["BND"] = "BND";
  ECurrencyCode["BOB"] = "BOB";
  ECurrencyCode["BOV"] = "BOV";
  ECurrencyCode["BRL"] = "BRL";
  ECurrencyCode["BSD"] = "BSD";
  ECurrencyCode["BTN"] = "BTN";
  ECurrencyCode["BWP"] = "BWP";
  ECurrencyCode["BYN"] = "BYN";
  ECurrencyCode["BZD"] = "BZD";
  ECurrencyCode["CAD"] = "CAD";
  ECurrencyCode["CDF"] = "CDF";
  ECurrencyCode["CHF"] = "CHF";
  ECurrencyCode["CLP"] = "CLP";
  ECurrencyCode["CNY"] = "CNY";
  ECurrencyCode["COP"] = "COP";
  ECurrencyCode["CRC"] = "CRC";
  ECurrencyCode["CUC"] = "CUC";
  ECurrencyCode["CUP"] = "CUP";
  ECurrencyCode["CVE"] = "CVE";
  ECurrencyCode["CZK"] = "CZK";
  ECurrencyCode["DJF"] = "DJF";
  ECurrencyCode["DKK"] = "DKK";
  ECurrencyCode["DOP"] = "DOP";
  ECurrencyCode["DZD"] = "DZD";
  ECurrencyCode["EGP"] = "EGP";
  ECurrencyCode["ERN"] = "ERN";
  ECurrencyCode["ETB"] = "ETB";
  ECurrencyCode["EUR"] = "EUR";
  ECurrencyCode["FJD"] = "FJD";
  ECurrencyCode["FKP"] = "FKP";
  ECurrencyCode["GBP"] = "GBP";
  ECurrencyCode["GEL"] = "GEL";
  ECurrencyCode["GHS"] = "GHS";
  ECurrencyCode["GIP"] = "GIP";
  ECurrencyCode["GMD"] = "GMD";
  ECurrencyCode["GNF"] = "GNF";
  ECurrencyCode["GTQ"] = "GTQ";
  ECurrencyCode["GYD"] = "GYD";
  ECurrencyCode["HKD"] = "HKD";
  ECurrencyCode["HNL"] = "HNL";
  ECurrencyCode["HRK"] = "HRK";
  ECurrencyCode["HTG"] = "HTG";
  ECurrencyCode["HUF"] = "HUF";
  ECurrencyCode["IDR"] = "IDR";
  ECurrencyCode["ILS"] = "ILS";
  ECurrencyCode["INR"] = "INR";
  ECurrencyCode["IQD"] = "IQD";
  ECurrencyCode["IRR"] = "IRR";
  ECurrencyCode["ISK"] = "ISK";
  ECurrencyCode["JMD"] = "JMD";
  ECurrencyCode["JOD"] = "JOD";
  ECurrencyCode["JPY"] = "JPY";
  ECurrencyCode["KES"] = "KES";
  ECurrencyCode["KGS"] = "KGS";
  ECurrencyCode["KHR"] = "KHR";
  ECurrencyCode["KMF"] = "KMF";
  ECurrencyCode["KPW"] = "KPW";
  ECurrencyCode["KRW"] = "KRW";
  ECurrencyCode["KWD"] = "KWD";
  ECurrencyCode["KYD"] = "KYD";
  ECurrencyCode["KZT"] = "KZT";
  ECurrencyCode["LAK"] = "LAK";
  ECurrencyCode["LBP"] = "LBP";
  ECurrencyCode["LKR"] = "LKR";
  ECurrencyCode["LRD"] = "LRD";
  ECurrencyCode["LSL"] = "LSL";
  ECurrencyCode["LYD"] = "LYD";
  ECurrencyCode["MAD"] = "MAD";
  ECurrencyCode["MDL"] = "MDL";
  ECurrencyCode["MGA"] = "MGA";
  ECurrencyCode["MKD"] = "MKD";
  ECurrencyCode["MMK"] = "MMK";
  ECurrencyCode["MNT"] = "MNT";
  ECurrencyCode["MOP"] = "MOP";
  ECurrencyCode["MRU"] = "MRU";
  ECurrencyCode["MUR"] = "MUR";
  ECurrencyCode["MVR"] = "MVR";
  ECurrencyCode["MWK"] = "MWK";
  ECurrencyCode["MXN"] = "MXN";
  ECurrencyCode["MYR"] = "MYR";
  ECurrencyCode["MZN"] = "MZN";
  ECurrencyCode["NAD"] = "NAD";
  ECurrencyCode["NGN"] = "NGN";
  ECurrencyCode["NIO"] = "NIO";
  ECurrencyCode["NOK"] = "NOK";
  ECurrencyCode["NPR"] = "NPR";
  ECurrencyCode["NZD"] = "NZD";
  ECurrencyCode["OMR"] = "OMR";
  ECurrencyCode["PAB"] = "PAB";
  ECurrencyCode["PEN"] = "PEN";
  ECurrencyCode["PGK"] = "PGK";
  ECurrencyCode["PHP"] = "PHP";
  ECurrencyCode["PKR"] = "PKR";
  ECurrencyCode["PLN"] = "PLN";
  ECurrencyCode["PYG"] = "PYG";
  ECurrencyCode["QAR"] = "QAR";
  ECurrencyCode["RON"] = "RON";
  ECurrencyCode["RSD"] = "RSD";
  ECurrencyCode["RUB"] = "RUB";
  ECurrencyCode["RWF"] = "RWF";
  ECurrencyCode["SAR"] = "SAR";
  ECurrencyCode["SBD"] = "SBD";
  ECurrencyCode["SCR"] = "SCR";
  ECurrencyCode["SDG"] = "SDG";
  ECurrencyCode["SEK"] = "SEK";
  ECurrencyCode["SGD"] = "SGD";
  ECurrencyCode["SHP"] = "SHP";
  ECurrencyCode["SLL"] = "SLL";
  ECurrencyCode["SOS"] = "SOS";
  ECurrencyCode["SRD"] = "SRD";
  ECurrencyCode["SSP"] = "SSP";
  ECurrencyCode["STN"] = "STN";
  ECurrencyCode["SVC"] = "SVC";
  ECurrencyCode["SYP"] = "SYP";
  ECurrencyCode["SZL"] = "SZL";
  ECurrencyCode["THB"] = "THB";
  ECurrencyCode["TJS"] = "TJS";
  ECurrencyCode["TMT"] = "TMT";
  ECurrencyCode["TND"] = "TND";
  ECurrencyCode["TOP"] = "TOP";
  ECurrencyCode["TRY"] = "TRY";
  ECurrencyCode["TTD"] = "TTD";
  ECurrencyCode["TWD"] = "TWD";
  ECurrencyCode["TZS"] = "TZS";
  ECurrencyCode["UAH"] = "UAH";
  ECurrencyCode["UGX"] = "UGX";
  ECurrencyCode["USD"] = "USD";
  ECurrencyCode["UYU"] = "UYU";
  ECurrencyCode["UZS"] = "UZS";
  ECurrencyCode["VES"] = "VES";
  ECurrencyCode["VND"] = "VND";
  ECurrencyCode["VUV"] = "VUV";
  ECurrencyCode["WST"] = "WST";
  ECurrencyCode["XAF"] = "XAF";
  ECurrencyCode["XCD"] = "XCD";
  ECurrencyCode["XOF"] = "XOF";
  ECurrencyCode["XPF"] = "XPF";
  ECurrencyCode["YER"] = "YER";
  ECurrencyCode["ZAR"] = "ZAR";
  ECurrencyCode["ZMW"] = "ZMW";
  ECurrencyCode["ZWL"] = "ZWL";
})(ECurrencyCode || (ECurrencyCode = {}));
export let ELanguage;
(function (ELanguage) {
  ELanguage["Amharic"] = "am";
  ELanguage["Arabic"] = "ar";
  ELanguage["Bengali"] = "bn";
  ELanguage["HakhaChin"] = "cn";
  ELanguage["German"] = "de";
  ELanguage["English"] = "en";
  ELanguage["Spanish"] = "es";
  ELanguage["Farsi"] = "fa";
  ELanguage["Falam"] = "fl";
  ELanguage["French"] = "fr";
  ELanguage["Greek"] = "gr";
  ELanguage["Gujarati"] = "gu";
  ELanguage["Hindi"] = "hi";
  ELanguage["HaitianCreole"] = "ht";
  ELanguage["Armenian"] = "hy";
  ELanguage["Italian"] = "it";
  ELanguage["Korean"] = "ko";
  ELanguage["Marathi"] = "mr";
  ELanguage["Burmese"] = "my";
  ELanguage["Punjabi"] = "pa";
  ELanguage["Polish"] = "pl";
  ELanguage["Portuguese"] = "pt";
  ELanguage["Russian"] = "ru";
  ELanguage["Tagalog"] = "tl";
  ELanguage["Ukrainian"] = "uk";
  ELanguage["Urdu"] = "ur";
  ELanguage["Vietnamese"] = "vi";
  ELanguage["ChineseSimplified"] = "zh";
  ELanguage["ChineseTraditional"] = "zh-t";
  ELanguage["Tigrinya"] = "ti";
  ELanguage["Khmer"] = "km";
  ELanguage["Somali"] = "so";
  ELanguage["Japanese"] = "ja";
  ELanguage["Thai"] = "th";
})(ELanguage || (ELanguage = {}));
export let ELocale;
(function (ELocale) {
  ELocale["EnglishUS"] = "en-US";
  ELocale["SpanishUS"] = "es-US";
  ELocale["PortugueseBR"] = "pt-BR";
})(ELocale || (ELocale = {}));
export let ECountry;
(function (ECountry) {
  ECountry["US"] = "US";
  ECountry["Brazil"] = "BR";
})(ECountry || (ECountry = {}));
export let EPatientRelationship;
(function (EPatientRelationship) {
  EPatientRelationship["Self"] = "self";
  EPatientRelationship["Spouse"] = "01";
  EPatientRelationship["Child"] = "19";
  EPatientRelationship["OtherAdult"] = "34";
})(EPatientRelationship || (EPatientRelationship = {}));
export let ERole;
(function (ERole) {
  ERole["Staff"] = "staff";
  ERole["Doctor"] = "doctor";
  ERole["Patient"] = "patient";
  ERole["PatientBookOnly"] = "patientBookOnly";
  ERole["PatientLoginOnly"] = "patientLoginOnly";
  ERole["Widget"] = "widget";
  ERole["Subaccount"] = "subaccount";
  ERole["Manager"] = "manager";
  ERole["Admin"] = "admin";
  ERole["TReferringProvider"] = "referringProvider";
  ERole["RenderingProvider"] = "renderingProvider";
  ERole["Lumalink"] = "lumalink";
  ERole["ReadFileUpload"] = "readFileUpload";
  ERole["UserInvitation"] = "userInvitation";
  ERole["Guest"] = "guest";
  ERole["ApiUser"] = "apiUser";
  ERole["ApiSettingsRead"] = "api:settings:read";
  ERole["ApiSettingsCreate"] = "api:settings:create";
  ERole["ApiPatientsRead"] = "api:patients:read";
  ERole["ApiPatientsCreate"] = "api:patients:create";
  ERole["ApiBillingTransactionsRead"] = "api:billingTransactions:read";
  ERole["ApiBillingTransactionsUpdate"] = "api:billingTransactions:update";
  ERole["ApiApiClientsRead"] = "api:apiClients:read";
  ERole["ApiApiClientsCreate"] = "api:apiClients:create";
  ERole["ApiApiClientsUpdate"] = "api:apiClients:update";
  ERole["ApiUsersRead"] = "api:users:read";
  ERole["ApiUsersCreate"] = "api:users:create";
  ERole["ApiUsersUpdate"] = "api:users:update";
})(ERole || (ERole = {}));
export let ESquiggly;
(function (ESquiggly) {
  ESquiggly["AppointmentDate"] = "{{appointment.date}}";
  ESquiggly["AppointmentLongdate"] = "{{appointment.longdate}}";
  ESquiggly["AppointmentDuration"] = "{{appointment.duration}}";
  ESquiggly["AppointmentStatus"] = "{{appointment.status}}";
  ESquiggly["FacilityAddress"] = "{{facility.address}}";
  ESquiggly["FacilitName"] = "{{facility.name}}";
  ESquiggly["FacilityPhone"] = "{{facility.phone}}";
  ESquiggly["FacilityAlternativePhone"] = "{{facility.alternativePhone}}";
  ESquiggly["FacilitySpecialInstructions"] = "{{facility.specialInstructions}}";
  ESquiggly["MeName"] = "{{me.name}}";
  ESquiggly["PatientFirstname"] = "{{patient.firstname}}";
  ESquiggly["ProviderName"] = "{{provider.name}}";
  ESquiggly["ProviderSpecialInstructions"] = "{{provider.specialInstructions}}";
  ESquiggly["SystemUrlInsuranceUrl"] = "{{system.url.insuranceUrl}}";
  ESquiggly["SystemUrlReminderConfirm"] = "{{system.url.reminder.confirm}}";
  ESquiggly["SystemUrlSelfScheduleUrl"] = "{{system.url.selfScheduleUrl}}";
  ESquiggly["SystemUrlChatUrl"] = "{{system.url.chatUrl}}";
  ESquiggly["RecallDate"] = "{{recall.date}}";
  ESquiggly["RecallMonthandyear"] = "{{recall.monthandyear}}";
  ESquiggly["AppointmentTypeName"] = "{{appointmentType.name}}";
  ESquiggly["AppointmentTypeSpecialInstructions"] = "{{appointmentType.specialInstructions}}";
  ESquiggly["FutureAppointmentDate"] = "{{futureAppointment.date}}";
  ESquiggly["FutureAppointmentLongdate"] = "{{futureAppointment.longdate}}";
  ESquiggly["AvailabilityDate"] = "{{availability.date}}";
  ESquiggly["DoNotContactMessageText"] = "{{doNotContactMessage.text}}";
  ESquiggly["FacilityAlternativeName"] = "{{facility.alternativeName}}";
  ESquiggly["FacilityPhonetic"] = "{{facility.phonetic}}";
  ESquiggly["MessageText"] = "{{message.text}}";
  ESquiggly["OfferId"] = "{{offer._id}}";
  ESquiggly["SystemUrlPatientFormUrl"] = "{{system.url.patientFormUrl}}";
  ESquiggly["PatientName"] = "{{patient.name}}";
  ESquiggly["PatientLastname"] = "{{patient.lastname}}";
  ESquiggly["PatientId"] = "{{patient._id}}";
  ESquiggly["ReferralCalledAtDate"] = "{{referral.calledAtDate}}";
  ESquiggly["ReferralReferringProvider"] = "{{referral.referringProvider}}";
  ESquiggly["UserId"] = "{{user._id}}";
  ESquiggly["UserName"] = "{{user.name}}";
  ESquiggly["UserEmail"] = "{{user.email}}";
  ESquiggly["UserSettingsCancellationExpiration"] = "{{user.settings.cancellation.expiration}}";
  ESquiggly["WaitlistId"] = "{{waitlist._id}}";
  ESquiggly["GroupInviteGroupName"] = "{{groupInvite.group.name}}";
  ESquiggly["SystemUrlGroupInviteInvite"] = "{{system.url.groupInvite.invite}}";
  ESquiggly["SystemContactValue"] = "{{system.contact.value}}";
  ESquiggly["SystemReferralInboundNumber"] = "{{system.referral.inboundNumber}}";
  ESquiggly["SystemUrlOfferValue"] = "{{system.url.offer.value}}";
  ESquiggly["SystemUrlAppointmentDecline"] = "{{system.url.appointment.decline}}";
  ESquiggly["SystemUrlAppointmentConfirm"] = "{{system.url.appointment.confirm}}";
  ESquiggly["SystemUrlReminderCancel"] = "{{system.url.reminder.cancel}}";
  ESquiggly["SystemUrlReferralCancel"] = "{{system.url.referral.cancel}}";
  ESquiggly["SystemUrlReferralSchedule"] = "{{system.url.referral.schedule}}";
  ESquiggly["SystemUrlReferralUrl"] = "{{system.url.referralUrl}}";
  ESquiggly["SystemUrlScoreFeedbackUrl"] = "{{system.url.scoreFeedbackUrl}}";
  ESquiggly["SystemUrlPositiveFeedbackUrl"] = "{{system.url.positiveFeedbackUrl}}";
  ESquiggly["SystemUrlNegativeFeedbackUrl"] = "{{system.url.negativeFeedbackUrl}}";
  ESquiggly["SystemUrlFeedbackPromoterType"] = "{{system.url.feedbackPromoterType}}";
})(ESquiggly || (ESquiggly = {}));